export default __webpack_public_path__ + "static/media/spinner.cea19e4e.gif";